module.exports = __webpack_public_path__ + "media/images/furleft-b72dac70fb901322bfcca2639872806b.jpg";